/* src/services/ai.js */
import { functions } from '../apiClient';

export const aiService = {

  // --- MEAL ANALYSIS ---
  analyzeMeal: async (base64Image, userDescription = "") => {
    try {
      console.log("AI Service: Sending request to analyze-meal...");

      const data = await functions.analyzeMeal({
        image: base64Image,
        comments: userDescription
      });

      console.log("AI Service: Received Data:", data);
      return data;

    } catch (error) {
      console.error("AI Service Fallback:", error);
      return createFallback(userDescription || "Analysis Failed (Connection)");
    }
  },

  // --- COURSE SUMMARY ---
  generateCourseSummary: async (courseId, userId) => {
    try {
      console.log("AI Service: Generating Course Summary...");

      const data = await functions.synthesizeCourse({ courseId, userId });
      return data;

    } catch (error) {
      console.error("Summary Generation Failed:", error);
      return { error: error.message };
    }
  }
};

function createFallback(summary) {
  return {
    summary: summary,
    nutrition: { calories: 0, protein_g: 0, carbs_g: 0, fat_g: 0, fiber_g: 0 }
  };
}
